export default __webpack_public_path__ + "static/media/GSP6.d591741c.png";